export default "__VITE_ASSET__DfJfpVI0__"